<template>
	<div class="container">



	    <Row :gutter="17">
	        <Col span="6">
	           <Button type="info" long class="btn" @click="openJypt">
	           		<img src="@/assets/index/btnList/certificate_icon.png" width="30px" height="30px" />
		    		<span class="btn-text">专利交易展示平台</span>
	          	</Button>
	        </Col>
	        <Col span="6">
	            <Button type="warning" long class="btn" @click="opengzdjf">
	           		<img src="@/assets/index/btnList/paying_icon.png" width="30px" height="30px" />
		    		<span class="btn-text">专利代缴费服务</span>
	          	</Button>
	        </Col>
	        <Col span="6">
	            <Button type="success" long class="btn" @click="openRetrieval">
	           		<img src="@/assets/index/btnList/search_icon.png" width="30px" height="30px" />
		    		<span class="btn-text">检索咨询服务</span>
	          	</Button>
	        </Col>
	      <Col span="6">
	            <Button type="primary" long class="btn" @click="openMetalcertificate">
	           		<img src="@/assets/index/btnList/trading_icon.png" width="30px" height="30px" />
		    		<span class="btn-text">金属专利证书制作</span>
	          	</Button>
	        </Col>
	    </Row>

	</div>

</template>

<script>
export default {
  name: 'btnList',
  data() {
		return {

		};
	},
	methods:{
		openJypt:function(){
			// window.open("https://mzipatent.com:81/#/login?version=jyzs");
			window.open("https://zlxq.mzipatent.com/");
		},
		opengzdjf:function(){
			//window.open("https://v1.mzipatent.com/resources/lib/login/djf.html");
			window.open("/#/generationpayment");
		},
		openMetalcertificate:function(){
			window.open("/#/metalcertificate");
		},
		openRetrieval:function(){
			window.open("/#/retrieval");
		}
	}
}
</script>

<style scoped>

	.btn{
		height: 70px;
	}
	.btn-text{
		font-size: 22px;
		line-height: 30px ;
		margin-top: -22px;
		margin-left: 10px;
		display:inline-block;
		vertical-align: middle;
	}

	.ivu-btn-info{
		background: linear-gradient(#58E3E0, #6BBFEB) !important;
		border-color:#6BBFEB;
	}
	.ivu-btn-info:hover{
		background: linear-gradient(#48D3D0, #6BBFEB) !important;
	}
	.ivu-btn-warning{
		background: linear-gradient(#F3DA76, #EDBD69) !important;
		border-color:#EDBD69;
	}
	.ivu-btn-warning:hover{
		background: linear-gradient(#E3CA66, #EDBD69) !important;
	}
	.ivu-btn-success{
		background: linear-gradient(#93B6EC, #8692DE) !important;
		border-color:#8692DE;
	}
	.ivu-btn-success:hover{
		background: linear-gradient(#83A6DC, #8692DE) !important;
	}
	.ivu-btn-primary{
		background: linear-gradient(#73BBE3, #6EA3D9) !important;
		border-color:#6EA3D9;
	}
	.ivu-btn-primary:hover{
		background: linear-gradient(#63ABD3, #6EA3D9) !important;
	}

</style>



// WEBPACK FOOTER //
// src/view/index/btnList/index.vue